import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { CustomRouteMobileViews } from '../interfaces/custom-route-mobile.interface';
import { CUSTOM_ROUTE_MOBILE_MAP } from '../config/constants';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class CustomRouteMobileViewsStateService {
  private _sessionStorageService = inject(SessionStorageService);
  
  public mobileViewsState: WritableSignal<CustomRouteMobileViews> = signal(CUSTOM_ROUTE_MOBILE_MAP.planner);
  
  setMobileViewsState(view: CustomRouteMobileViews): void {
    this.mobileViewsState.set(view);
    this._sessionStorageService.setItem('customRouteMobileViewsState', view);
  }
  
}
